<!--Страница отображающая подтверждение почты-->
<template>
  <v-container class="page-content px-5" style="width: 100%">
    <div v-if="loading === false">
      <v-row no-gutters class="justify-center">
        <v-icon
          v-if="accept"
          size="250"
          color="green"
        >
          check_circle_outline
        </v-icon>
        <v-icon
          v-else
          size="250"
          color="red"
        >
          error
        </v-icon>
      </v-row>
      <v-row no-gutters class="justify-center text-h5 text-md-h4 mt-6 font-weight-bold">
        <span v-if="accept"> Почта была подтверждена!</span>
        <span v-else>Ошибка подтверждения</span>
      </v-row>
      <v-row no-gutters class="justify-center mt-10">
        <v-btn
          v-if="!accept"
          color="primary"
          elevation="4"
          x-large
          rounded
          @click="regApprove()"
        >
          Повторить отправку
        </v-btn>
      </v-row>
    </div>

    <div class="action mt-16 mb-4 align-center" v-else>
      <semipolar-spinner
        class="d-inline-block"
        :animation-duration="2000"
        :size="115"
        color="#1935ff"
      />
    </div>
  </v-container>
</template>

<script>

import router from "@/router"
import names from '@/modules/profile/routers/names'
import { mapActions } from 'vuex'

/**
 * Компонент подтверждения электронной почты
 * Отображает результат подтверждения email пользователя
 */
export default {
  name: 'ApproveMail',

  /**
   * Хук жизненного цикла: выполняется при создании компонента
   * Запускает процесс подтверждения почты
   */
  created: function () {
    this.regApprove()
  },

  /**
   * Возвращает начальное состояние данных компонента
   * @returns {Object} объект с начальными данными
   */
  data () {
    return {
      loading: true,
      accept: false,
    }
  },

  computed: {
    /**
     * Карта имён маршрутов для навигации
     * @type {Object}
     */
    names: () => names,
  },

  methods: {
    ...mapActions({
      /**
       * Действие Vuex для подтверждения email
       * @type {Function}
       */
      approveEmail: 'user/approveEmail',
    }),

    /**
     * Метод подтверждения регистрации
     * Выполняет запрос на подтверждение email с использованием токена из URL
     * Обрабатывает успешное и неуспешное выполнение запроса
     * @returns {void}
     */
    regApprove () {
      const data = {
        token: this.$route.params.token
      }

      this.approveEmail({
        data,
        /**
         * Функция-обработчик успешного подтверждения
         * Устанавливает флаг успеха, скрывает загрузку и перенаправляет на главную страницу через 2 секунды
         * @param {Object} data - данные ответа
         * @param {string} url - URL запроса
         */
        finalizer: (data, url) => {
          this.accept = true
          this.loading = false
          setTimeout(() => {
            router.push({ name: names.BASE })
          }, 2000)
        },
        /**
         * Функция-обработчик ошибки подтверждения
         * Скрывает индикатор загрузки при возникновении ошибки
         * @param {Object} data - данные ошибки
         * @param {string} url - URL запроса
         */
        catcher: (data, url) => {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
